import React from 'react';
import LegalLayout from '../components/common/LegalLayout';

const faqEntries = [
  ['학원과 어떻게 다른가요?', 'ElectroWave Club은 학원이 아니라 1:1 멘토 매칭 스터디 클럽입니다. 정해진 시간표가 아닌 학생-멘토 합의 커리큘럼으로 작은 프로젝트를 끝까지 완성합니다.'],
  ['누구나 신청할 수 있나요?', '자격 제한은 없습니다. 전공 학생, 비전공 직장인, 취준생, 멘토 역할의 5년 차 이상 현업 개발자까지 모두 신청 가능합니다.'],
  ['코딩을 한 번도 해본 적이 없는데 괜찮을까요?', '괜찮습니다. 입문자에게는 멘토가 페어 프로그래밍 방식으로 차근차근 함께 코드를 씁니다.'],
  ['멘토와 결이 맞지 않으면 어떻게 하나요?', '첫 1회 오리엔테이션 후 결이 맞지 않으면 다른 멘토 후보로 추가 비용 없이 변경 가능합니다.'],
  ['회비는 얼마인가요?', '60분 × 월 4회 단일 구성으로 일반 기초 20만원, 일반 응용 32만원, AI 기초 36만원, AI 응용 48만원입니다. 자세한 내용은 회비 안내 페이지를 참고해 주세요.'],
  ['결제 후 환불이 가능한가요?', '가능합니다. 첫 미팅 전에는 전액 환불, 진행 중에는 회차 기준으로 환불됩니다. 자세한 기준은 환불 정책 페이지에 명시되어 있습니다.'],
  ['온라인으로만 진행되나요?', '화상 미팅은 Zoom을 사용하여 진행합니다. 학생과 멘토가 같은 지역에 있고 양쪽이 원하면 오프라인 미팅도 가능합니다.'],
  ['결과물의 저작권은 누구에게 있나요?', '학생에게 있습니다. 클럽은 학습 결과물에 대한 권리를 가지지 않으며 공개·비공개를 학생이 자유롭게 결정합니다.'],
  ['AI 도구를 활용해도 되나요?', '적극 권장합니다. AI 도구를 막지도, 무작정 의존하지도 않으며 어디까지 맡기고 어디서 사람이 검증해야 하는지 배우는 것이 학습의 일부입니다.'],
  ['회사 단위로 신청해도 되나요?', '가능합니다. 신입·주니어 온보딩이나 사내 학습 프로그램 형태의 매칭도 운영하며 별도 견적으로 안내드립니다.'],
];

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqEntries.map(([q, a]) => ({
    '@type': 'Question',
    name: q,
    acceptedAnswer: { '@type': 'Answer', text: a },
  })),
};

const FaqPage = () => (
  <LegalLayout
    title="자주 묻는 질문"
    subtitle="상담 전에 가장 많이 받는 질문을 정리했습니다. 여기에 없는 내용은 교육상담을 통해 답변드립니다."
    helmetDescription="ElectroWave Club 자주 묻는 질문 — 1:1 멘토 매칭, 회비, 환불, 줌 학습 방식 등 운영 전반에 대한 답변."
    accentColor="#6366f1"
    jsonLd={faqJsonLd}
  >
    <h2>1. 학원과 어떻게 다른가요?</h2>
    <p>
      ElectroWave Club은 학원이 아니라 스터디 클럽입니다. 정해진 시간표에 맞춰 같은 영상을 함께 보는 방식이
      아니라, 각 학생을 현업 멘토와 1:1로 매칭해 작은 프로젝트를 끝까지 완성하는 형태로 운영됩니다.
      커리큘럼은 멘토와 학생이 첫 미팅에서 함께 정합니다.
    </p>

    <h2>2. 누구나 신청할 수 있나요?</h2>
    <p>
      자격 제한은 없습니다. 전공 학생, 비전공 직장인, 취준생, 그리고 멘토 역할로 참여하고 싶은 5년 차 이상의
      현업 개발자까지 모두 신청 가능합니다. 신청서에 본인의 현재 상태를 솔직히 적어 주시면 그에 맞춰 안내해
      드립니다.
    </p>

    <h2>3. 코딩을 한 번도 해본 적이 없는데 괜찮을까요?</h2>
    <p>
      괜찮습니다. 입문자에게는 멘토가 처음부터 차근차근 함께 코드를 쓰는 페어 프로그래밍 방식으로 진행합니다.
      "혼자 책을 펴고 따라가는 학습"에서 멈추지 않도록 옆에서 길을 잡아 드리는 게 멘토의 역할입니다.
    </p>

    <h2>4. 멘토와 결이 맞지 않으면 어떻게 하나요?</h2>
    <p>
      첫 1회 오리엔테이션 후 결이 맞지 않다고 판단되면 운영자에게 알려 주세요. 다른 멘토 후보로 바꿔 드리며,
      이 과정에서 추가 비용은 들지 않습니다. 좋은 매칭이 학습의 절반이라고 생각합니다.
    </p>

    <h2>5. 회비는 얼마인가요?</h2>
    <p>
      과정의 길이, 난이도, 주간 미팅 횟수에 따라 달라지기 때문에 표준 가격표 대신 1:1 상담을 통해 안내해
      드립니다. 회비는 멘토 사례비와 클럽 운영비로 사용되며, 별도의 교재비·플랫폼 사용료는 없습니다. 자세한
      내용은 <a href="/tuition">교육비 안내</a> 페이지를 참고해 주세요.
    </p>

    <h2>6. 결제 후 환불이 가능한가요?</h2>
    <p>
      가능합니다. 첫 미팅 전에는 전액 환불, 진행 중에는 남은 회차 기준으로 환불됩니다. 자세한 기준은{' '}
      <a href="/refund-policy">환불 정책</a> 페이지에서 확인해 주세요.
    </p>

    <h2>7. 온라인으로만 진행되나요? 오프라인 모임은 없나요?</h2>
    <p>
      기본은 온라인(화상 + 비동기 메시지)이지만, 학생과 멘토가 같은 지역에 있고 양쪽이 원하면 오프라인 미팅도
      가능합니다. 정기 오프라인 정모는 분기 1회 정도 운영을 검토 중입니다.
    </p>
    <p>
      <strong>화상 미팅은 Zoom을 사용하여 진행합니다.</strong>
    </p>

    <h2>8. 결과물의 저작권은 누구에게 있나요?</h2>
    <p>
      학생에게 있습니다. 클럽은 학습 결과물에 대한 권리를 가지지 않으며, 공개·비공개도 학생이 자유롭게
      결정합니다. 다만 학생이 동의하는 경우에 한해, 후기·포트폴리오 일부를 클럽 소개에 사용할 수 있습니다.
    </p>

    <h2>9. AI 도구를 활용해도 되나요?</h2>
    <p>
      적극 권장합니다. ElectroWave Club은 AI 도구를 무작정 막거나 무작정 의존하는 양극단을 모두 피합니다.
      어디까지 맡기고 어디서 사람이 검증해야 하는지를 배우는 것이 학습의 일부입니다.
    </p>

    <h2>10. 회사 단위로 신청해도 되나요?</h2>
    <p>
      가능합니다. 신입·주니어 온보딩이나 사내 학습 프로그램 형태의 매칭도 운영합니다. 인원, 기간, 도메인을
      알려 주시면 별도 견적으로 안내드립니다.
    </p>
  </LegalLayout>
);

export default FaqPage;
